module.exports = ".table-filter {\r\n    text-align: left;\r\n}\r\n\r\n.table-filter-input {\r\n    width: 50%;\r\n    margin-left: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n/* https://stackoverflow.com/a/38781945/483776 */\r\n\r\n.fa.disabled,\r\n.fa[disabled],\r\n.disabled > .fa,\r\n[disabled] > .fa {\r\n    opacity: 0.25;\r\n    pointer-events: none;\r\n    /* cursor: not-allowed; */\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/training-sessions-list/training-sessions-list.component.css
// module id = ./src/app/components/training-sessions-list/training-sessions-list.component.css
// module chunks = main